<div class="annual-plan-graph-dialog">
    <h1 mat-dialog-title>
        {{ 'Week' | translate}} {{ week.realWeekNumber || week.weekNumber }}
        <span *ngIf="week.realWeekNumber">{{ week.firstDayOfWeek|appDate:'mediumDate' }} - {{ week.lastDayOfWeek|appDate:'mediumDate' }}</span>
    </h1>
    <div mat-dialog-content>
        <ul id="legend">
            <li class="physical">{{ 'Physical'|translate }} <span>{{ week.physicalPercent }} %</span></li>
            <li class="sport">{{ 'Sport'|translate }} <span>{{ week.sportPercent }} %</span></li>
            <li class="intensity">{{ 'Intensity'|translate }} <span>{{ week.intensityPercent }} %</span></li>
        </ul>

        <hr />

        <div *ngIf="0 < week.exerciseCategories.length; else noCategories">
            <ul id="accents">
                <li class="competition" *ngFor="let category of week.exerciseCategories">
                    <span class="bullet" [ngStyle]="{'background': category.colorHex}"></span> {{ category.name }}
                </li>
            </ul>
        </div>

        <ng-template #noCategories>
            {{ 'message.no_accent'|translate }}
        </ng-template>

        <hr />

        <ul id="events">
            <li>{{ week.comment || 'message.no_event_comment'|translate }}</li>
        </ul>
    </div>
    <div mat-dialog-actions
         class="actions">
        <button mat-raised-button [mat-dialog-close]="" color="accent">{{ 'Close'|translate }}</button>
    </div>
</div>
